/**
 * Erase the "time" part of a datetime and returns its midnight-UTC representation.
 *
 * @example
 *   // Provided "now" is 2023-07-24T01:12:00 in Europe/Paris timezone (GMT+2)
 *   const date = new Date();
 *   console.log(date.toISOString()); // '2023-07-23T23:12:00.000Z'
 *
 *   const utcDate = datetimeToLocalDateUtc(date);
 *   console.log(utcDate.toISOString()); // '2023-07-24T00:00:00.000Z'
 */
const datetimeToLocalDateUtc = (date: Date) => {
  const utcTimestamp = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );

  return new Date(utcTimestamp);
};

export default datetimeToLocalDateUtc;
